import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
import Recognized from "@/pages/recognized/Recognized";

const RecognizedRouter = [
  {
    path: "recognized",
    element: (
      <SuspenseWrapper>
        <Recognized />
      </SuspenseWrapper>
    ),
  },
];

export default RecognizedRouter;
